// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1UfUM","label":"Labeled_label__1Xl7g","divider":"Labeled_divider__1dJLJ"};